var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid search", attrs: { id: "search" } },
    [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "row justify-content-between" }, [
            _c(
              "div",
              {
                staticClass:
                  "container-search col-xl-6 col-lg-12 col-md-12 col-sm-12"
              },
              [
                !_vm.showHeading
                  ? _c("h2", [_vm._v("Market Research")])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    on: {
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.doSearch.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _c("table", { staticClass: "search" }, [
                      _c("tr", { staticClass: "field-group" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "field", attrs: { colspan: "3" } },
                          [
                            _c("input", {
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                readonly: "",
                                id: "make",
                                name: _vm.getNameField(
                                  "make",
                                  _vm.selected_makes_proxy
                                ),
                                placeholder: "Make"
                              },
                              domProps: { value: _vm.makeString },
                              on: {
                                click: function($event) {
                                  _vm.show_make_modal = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "b-modal",
                              {
                                ref: "ModalMake",
                                attrs: {
                                  size: "lg",
                                  id: "modal-make",
                                  "hide-footer": "",
                                  title: "Select make"
                                },
                                on: { hidden: _vm.onHideMakeModal },
                                model: {
                                  value: _vm.show_make_modal,
                                  callback: function($$v) {
                                    _vm.show_make_modal = $$v
                                  },
                                  expression: "show_make_modal"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "content-list-models" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group inline-label"
                                      },
                                      [
                                        _c(
                                          "label",
                                          { attrs: { for: "models-in-modal" } },
                                          [_vm._v("Make")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: {
                                            type: "text",
                                            readonly: "",
                                            id: "makes-in-modal",
                                            placeholder: "Make"
                                          },
                                          domProps: { value: _vm.makeString }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "link",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                _vm.selected_makes_proxy = {}
                                              }
                                            }
                                          },
                                          [_vm._v("Clear")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                _vm.show_make_modal = false
                                              }
                                            }
                                          },
                                          [_vm._v("Done")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "list-of-models" },
                                      [
                                        _vm._l(_vm.makes, function(
                                          vehiclemake
                                        ) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "model" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "checkbox" },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm
                                                              .selected_makes_proxy[
                                                              vehiclemake.value
                                                            ],
                                                          expression:
                                                            "selected_makes_proxy[vehiclemake.value]"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "checkbox",
                                                        id:
                                                          "make-" +
                                                          vehiclemake.value
                                                      },
                                                      domProps: {
                                                        value:
                                                          vehiclemake.value,
                                                        checked: Array.isArray(
                                                          _vm
                                                            .selected_makes_proxy[
                                                            vehiclemake.value
                                                          ]
                                                        )
                                                          ? _vm._i(
                                                              _vm
                                                                .selected_makes_proxy[
                                                                vehiclemake
                                                                  .value
                                                              ],
                                                              vehiclemake.value
                                                            ) > -1
                                                          : _vm
                                                              .selected_makes_proxy[
                                                              vehiclemake.value
                                                            ]
                                                      },
                                                      on: {
                                                        change: [
                                                          function($event) {
                                                            var $$a =
                                                                _vm
                                                                  .selected_makes_proxy[
                                                                  vehiclemake
                                                                    .value
                                                                ],
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v =
                                                                  vehiclemake.value,
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  _vm.$set(
                                                                    _vm.selected_makes_proxy,
                                                                    vehiclemake.value,
                                                                    $$a.concat([
                                                                      $$v
                                                                    ])
                                                                  )
                                                              } else {
                                                                $$i > -1 &&
                                                                  _vm.$set(
                                                                    _vm.selected_makes_proxy,
                                                                    vehiclemake.value,
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      )
                                                                  )
                                                              }
                                                            } else {
                                                              _vm.$set(
                                                                _vm.selected_makes_proxy,
                                                                vehiclemake.value,
                                                                $$c
                                                              )
                                                            }
                                                          },
                                                          _vm.onMakeChange
                                                        ]
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "label",
                                                      {
                                                        attrs: {
                                                          for:
                                                            "make-" +
                                                            vehiclemake.value
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            vehiclemake.name
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "field-group" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "field", attrs: { colspan: "3" } },
                          [
                            _c("input", {
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                readonly: "",
                                id: "model",
                                name: _vm.getNameField(
                                  "model",
                                  _vm.selected_models_proxy
                                ),
                                placeholder: "Model"
                              },
                              domProps: { value: _vm.modelString },
                              on: {
                                click: function($event) {
                                  _vm.show_model_modal = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "b-modal",
                              {
                                ref: "ModalModel",
                                attrs: {
                                  size: "lg",
                                  id: "modal-model",
                                  "hide-footer": "",
                                  title: "Select models"
                                },
                                on: { hidden: _vm.onHideModelModal },
                                model: {
                                  value: _vm.show_model_modal,
                                  callback: function($$v) {
                                    _vm.show_model_modal = $$v
                                  },
                                  expression: "show_model_modal"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "content-list-models" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "form-group inline-label"
                                      },
                                      [
                                        _c(
                                          "label",
                                          { attrs: { for: "models-in-modal" } },
                                          [_vm._v("Models")]
                                        ),
                                        _vm._v(" "),
                                        _c("input", {
                                          attrs: {
                                            type: "text",
                                            readonly: "",
                                            id: "models-in-modal",
                                            placeholder: "Models"
                                          },
                                          domProps: { value: _vm.modelString }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "link",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                _vm.selected_models_proxy = {}
                                              }
                                            }
                                          },
                                          [_vm._v("Clear")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                _vm.show_model_modal = false
                                              }
                                            }
                                          },
                                          [_vm._v("Done")]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.isModelLoading
                                      ? _c(
                                          "div",
                                          { staticClass: "loading-models" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: "/images/loading.svg",
                                                width: "50",
                                                alt: "Loading"
                                              }
                                            })
                                          ]
                                        )
                                      : [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "info-tabs info-single-vehicle"
                                            },
                                            [
                                              _c(
                                                "ul",
                                                {
                                                  staticClass: "nav nav-tabs",
                                                  attrs: { role: "tablist" }
                                                },
                                                _vm._l(
                                                  Object.keys(_vm.models),
                                                  function(key) {
                                                    return _c("li", [
                                                      _c(
                                                        "a",
                                                        {
                                                          class: {
                                                            active:
                                                              key ===
                                                              Object.keys(
                                                                _vm.models
                                                              ).shift()
                                                          },
                                                          attrs: {
                                                            "data-toggle":
                                                              "tab",
                                                            href:
                                                              "#modelGroup" +
                                                              key.replace(
                                                                " ",
                                                                ""
                                                              ),
                                                            role: "tab"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                                " +
                                                              _vm._s(key) +
                                                              "\n                                                            "
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  }
                                                ),
                                                0
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "tab-content" },
                                                [
                                                  _vm._l(_vm.models, function(
                                                    vehiclemodellist,
                                                    key
                                                  ) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          class: {
                                                            "tab-pane": true,
                                                            active:
                                                              key ===
                                                              Object.keys(
                                                                _vm.models
                                                              ).shift(),
                                                            show:
                                                              key ===
                                                              Object.keys(
                                                                _vm.models
                                                              ).shift(),
                                                            fade: true
                                                          },
                                                          attrs: {
                                                            id:
                                                              "modelGroup" +
                                                              key.replace(
                                                                " ",
                                                                ""
                                                              )
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "list-of-models"
                                                            },
                                                            [
                                                              _vm._l(
                                                                vehiclemodellist,
                                                                function(
                                                                  vehiclemodel
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "model"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "split-count"
                                                                          },
                                                                          [
                                                                            vehiclemodel.children &&
                                                                            vehiclemodel
                                                                              .children
                                                                              .length
                                                                              ? [
                                                                                  _c(
                                                                                    "a",
                                                                                    {
                                                                                      attrs: {
                                                                                        href:
                                                                                          "#!"
                                                                                      },
                                                                                      on: {
                                                                                        click: function(
                                                                                          $event
                                                                                        ) {
                                                                                          $event.preventDefault()
                                                                                          return _vm.openModelGroup(
                                                                                            vehiclemodel.value
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          vehiclemodel
                                                                                            .children
                                                                                            .length
                                                                                        )
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                ]
                                                                              : _vm._e()
                                                                          ],
                                                                          2
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "checkbox"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "input",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      _vm
                                                                                        .selected_models_proxy[
                                                                                        vehiclemodel.value +
                                                                                          "*"
                                                                                      ],
                                                                                    expression:
                                                                                      "selected_models_proxy[`${vehiclemodel.value}*`]"
                                                                                  }
                                                                                ],
                                                                                attrs: {
                                                                                  type:
                                                                                    "checkbox",
                                                                                  id:
                                                                                    "model-" +
                                                                                    vehiclemodel.value
                                                                                },
                                                                                domProps: {
                                                                                  value:
                                                                                    vehiclemodel.value,
                                                                                  checked: Array.isArray(
                                                                                    _vm
                                                                                      .selected_models_proxy[
                                                                                      vehiclemodel.value +
                                                                                        "*"
                                                                                    ]
                                                                                  )
                                                                                    ? _vm._i(
                                                                                        _vm
                                                                                          .selected_models_proxy[
                                                                                          vehiclemodel.value +
                                                                                            "*"
                                                                                        ],
                                                                                        vehiclemodel.value
                                                                                      ) >
                                                                                      -1
                                                                                    : _vm
                                                                                        .selected_models_proxy[
                                                                                        vehiclemodel.value +
                                                                                          "*"
                                                                                      ]
                                                                                },
                                                                                on: {
                                                                                  change: function(
                                                                                    $event
                                                                                  ) {
                                                                                    var $$a =
                                                                                        _vm
                                                                                          .selected_models_proxy[
                                                                                          vehiclemodel.value +
                                                                                            "*"
                                                                                        ],
                                                                                      $$el =
                                                                                        $event.target,
                                                                                      $$c = $$el.checked
                                                                                        ? true
                                                                                        : false
                                                                                    if (
                                                                                      Array.isArray(
                                                                                        $$a
                                                                                      )
                                                                                    ) {
                                                                                      var $$v =
                                                                                          vehiclemodel.value,
                                                                                        $$i = _vm._i(
                                                                                          $$a,
                                                                                          $$v
                                                                                        )
                                                                                      if (
                                                                                        $$el.checked
                                                                                      ) {
                                                                                        $$i <
                                                                                          0 &&
                                                                                          _vm.$set(
                                                                                            _vm.selected_models_proxy,
                                                                                            vehiclemodel.value +
                                                                                              "*",
                                                                                            $$a.concat(
                                                                                              [
                                                                                                $$v
                                                                                              ]
                                                                                            )
                                                                                          )
                                                                                      } else {
                                                                                        $$i >
                                                                                          -1 &&
                                                                                          _vm.$set(
                                                                                            _vm.selected_models_proxy,
                                                                                            vehiclemodel.value +
                                                                                              "*",
                                                                                            $$a
                                                                                              .slice(
                                                                                                0,
                                                                                                $$i
                                                                                              )
                                                                                              .concat(
                                                                                                $$a.slice(
                                                                                                  $$i +
                                                                                                    1
                                                                                                )
                                                                                              )
                                                                                          )
                                                                                      }
                                                                                    } else {
                                                                                      _vm.$set(
                                                                                        _vm.selected_models_proxy,
                                                                                        vehiclemodel.value +
                                                                                          "*",
                                                                                        $$c
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "label",
                                                                              {
                                                                                attrs: {
                                                                                  for:
                                                                                    "model-" +
                                                                                    vehiclemodel.value
                                                                                }
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    vehiclemodel.name
                                                                                  ) +
                                                                                    " (" +
                                                                                    _vm._s(
                                                                                      vehiclemodel.count
                                                                                    ) +
                                                                                    ")"
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _vm
                                                                      .open_model_groups[
                                                                      vehiclemodel
                                                                        .value
                                                                    ] &&
                                                                    vehiclemodel.children &&
                                                                    vehiclemodel
                                                                      .children
                                                                      .length
                                                                      ? _vm._l(
                                                                          vehiclemodel.children,
                                                                          function(
                                                                            child
                                                                          ) {
                                                                            return _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "model"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "split-count"
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "split-count"
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "span",
                                                                                  {
                                                                                    staticClass:
                                                                                      "checkbox"
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "input",
                                                                                      {
                                                                                        directives: [
                                                                                          {
                                                                                            name:
                                                                                              "model",
                                                                                            rawName:
                                                                                              "v-model",
                                                                                            value:
                                                                                              _vm
                                                                                                .selected_models_proxy[
                                                                                                child
                                                                                                  .value
                                                                                              ],
                                                                                            expression:
                                                                                              "selected_models_proxy[child.value]"
                                                                                          }
                                                                                        ],
                                                                                        attrs: {
                                                                                          type:
                                                                                            "checkbox",
                                                                                          id:
                                                                                            "model-" +
                                                                                            child.value.replace(
                                                                                              " ",
                                                                                              ""
                                                                                            )
                                                                                        },
                                                                                        domProps: {
                                                                                          value:
                                                                                            child.value,
                                                                                          checked: Array.isArray(
                                                                                            _vm
                                                                                              .selected_models_proxy[
                                                                                              child
                                                                                                .value
                                                                                            ]
                                                                                          )
                                                                                            ? _vm._i(
                                                                                                _vm
                                                                                                  .selected_models_proxy[
                                                                                                  child
                                                                                                    .value
                                                                                                ],
                                                                                                child.value
                                                                                              ) >
                                                                                              -1
                                                                                            : _vm
                                                                                                .selected_models_proxy[
                                                                                                child
                                                                                                  .value
                                                                                              ]
                                                                                        },
                                                                                        on: {
                                                                                          change: function(
                                                                                            $event
                                                                                          ) {
                                                                                            var $$a =
                                                                                                _vm
                                                                                                  .selected_models_proxy[
                                                                                                  child
                                                                                                    .value
                                                                                                ],
                                                                                              $$el =
                                                                                                $event.target,
                                                                                              $$c = $$el.checked
                                                                                                ? true
                                                                                                : false
                                                                                            if (
                                                                                              Array.isArray(
                                                                                                $$a
                                                                                              )
                                                                                            ) {
                                                                                              var $$v =
                                                                                                  child.value,
                                                                                                $$i = _vm._i(
                                                                                                  $$a,
                                                                                                  $$v
                                                                                                )
                                                                                              if (
                                                                                                $$el.checked
                                                                                              ) {
                                                                                                $$i <
                                                                                                  0 &&
                                                                                                  _vm.$set(
                                                                                                    _vm.selected_models_proxy,
                                                                                                    child.value,
                                                                                                    $$a.concat(
                                                                                                      [
                                                                                                        $$v
                                                                                                      ]
                                                                                                    )
                                                                                                  )
                                                                                              } else {
                                                                                                $$i >
                                                                                                  -1 &&
                                                                                                  _vm.$set(
                                                                                                    _vm.selected_models_proxy,
                                                                                                    child.value,
                                                                                                    $$a
                                                                                                      .slice(
                                                                                                        0,
                                                                                                        $$i
                                                                                                      )
                                                                                                      .concat(
                                                                                                        $$a.slice(
                                                                                                          $$i +
                                                                                                            1
                                                                                                        )
                                                                                                      )
                                                                                                  )
                                                                                              }
                                                                                            } else {
                                                                                              _vm.$set(
                                                                                                _vm.selected_models_proxy,
                                                                                                child.value,
                                                                                                $$c
                                                                                              )
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    ),
                                                                                    _vm._v(
                                                                                      " "
                                                                                    ),
                                                                                    _c(
                                                                                      "label",
                                                                                      {
                                                                                        attrs: {
                                                                                          for:
                                                                                            "model-" +
                                                                                            child.value.replace(
                                                                                              " ",
                                                                                              ""
                                                                                            )
                                                                                        }
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            child.name
                                                                                          )
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          }
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  })
                                                ],
                                                2
                                              )
                                            ]
                                          )
                                        ]
                                  ],
                                  2
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "field-group field-half" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("td", { staticClass: "field" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxy_data.year_min,
                                  expression: "proxy_data.year_min"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "year_min",
                                name: _vm.getNameField("year_min")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.proxy_data,
                                      "year_min",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.onChange("year_min")
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "", selected: "" } },
                                [_vm._v("Min")]
                              ),
                              _vm._v(" "),
                              !_vm.years.length
                                ? _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: _vm.proxy_data.year_min
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.proxy_data.year_min))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.years, function(year) {
                                return _c(
                                  "option",
                                  { domProps: { value: year } },
                                  [_vm._v(_vm._s(year))]
                                )
                              })
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        _vm._m(3),
                        _vm._v(" "),
                        _c("td", { staticClass: "field" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxy_data.year_max,
                                  expression: "proxy_data.year_max"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "year_max",
                                name: _vm.getNameField("year_max")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.proxy_data,
                                      "year_max",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.onChange("year_max")
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "", selected: "" } },
                                [_vm._v("Max")]
                              ),
                              _vm._v(" "),
                              !_vm.years.length
                                ? _c(
                                    "option",
                                    {
                                      domProps: {
                                        value: _vm.proxy_data.year_max
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.proxy_data.year_max))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.years, function(year) {
                                return _c(
                                  "option",
                                  { domProps: { value: year } },
                                  [_vm._v(_vm._s(year))]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "field-group field-half" }, [
                        _c(
                          "td",
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                attrs: {
                                  target: "conditionToolTipPopup",
                                  title: "",
                                  triggers: "hover focus"
                                }
                              },
                              [
                                _c("p", [
                                  _c("strong", [_vm._v("Vehicle Condition")])
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Each vehicle in an auction is given an overall condition rating by the auction house based on inspection."
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "This is sometimes also refered to as a condition grade. Generally, the higher the number is, the better the quality of the car."
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Auction grades of 1.0 are a possible exceptions. 1.0 represents modified cars, which can actually be of a high quality, but the modifications make it difficult to compare such vehicles to their non-modified counterparts."
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Cars with condition 0.0 are accident and accident repaired cars. Cars with 0.1 are accident or accident reparied cars that have been modified."
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Cars with condition 5.0 are like new vehicles."
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Cars with condition 9.0 are usually new, or nearly new, vehicles."
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", { staticClass: "field" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxy_data.condition_min,
                                  expression: "proxy_data.condition_min"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "condition_min",
                                name: _vm.getNameField("condition_min")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.proxy_data,
                                      "condition_min",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.onChange("condition_min")
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("Min")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 0 } }, [
                                _vm._v("0.0")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 2 } }, [
                                _vm._v("2.0")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 3 } }, [
                                _vm._v("3.0")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 3.5 } }, [
                                _vm._v("3.5")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 4 } }, [
                                _vm._v("4.0")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 4.5 } }, [
                                _vm._v("4.5")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 5 } }, [
                                _vm._v("5.0")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 9 } }, [
                                _vm._v("9.0")
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._m(5),
                        _vm._v(" "),
                        _c("td", { staticClass: "field" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxy_data.condition_max,
                                  expression: "proxy_data.condition_max"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                id: "condition_max",
                                name: _vm.getNameField("condition_max")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.proxy_data,
                                      "condition_max",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.onChange("condition_max")
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "", selected: "" } },
                                [_vm._v("Max")]
                              ),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 0 } }, [
                                _vm._v("0.0")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 2 } }, [
                                _vm._v("2.0")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 3 } }, [
                                _vm._v("3.0")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 3.5 } }, [
                                _vm._v("3.5")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 4 } }, [
                                _vm._v("4.0")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 4.5 } }, [
                                _vm._v("4.5")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 5 } }, [
                                _vm._v("5.0")
                              ]),
                              _vm._v(" "),
                              _c("option", { domProps: { value: 9 } }, [
                                _vm._v("9.0")
                              ])
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "field-group field-half" }, [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("td", { staticClass: "field" }, [
                          _c("div", { staticClass: "inline-flex" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxy_data.mileage_min,
                                  expression: "proxy_data.mileage_min"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", id: "mileage_min" },
                              domProps: { value: _vm.proxy_data.mileage_min },
                              on: {
                                change: function($event) {
                                  return _vm.onChangeMinMax("mileage_min")
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.proxy_data,
                                    "mileage_min",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v(",000")])
                          ]),
                          _vm._v(" "),
                          _vm.data.mileage_min
                            ? _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  type: "hidden",
                                  name: _vm.getNameField("mileage_min")
                                },
                                domProps: { value: _vm.data.mileage_min }
                              })
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._m(7),
                        _vm._v(" "),
                        _c("td", { staticClass: "field" }, [
                          _c("div", { staticClass: "inline-flex" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxy_data.mileage_max,
                                  expression: "proxy_data.mileage_max"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", id: "mileage_max" },
                              domProps: { value: _vm.proxy_data.mileage_max },
                              on: {
                                change: function($event) {
                                  return _vm.onChangeMinMax("mileage_max")
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.proxy_data,
                                    "mileage_max",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v(",000")])
                          ]),
                          _vm._v(" "),
                          _vm.data.mileage_max
                            ? _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  type: "hidden",
                                  name: _vm.getNameField("mileage_max")
                                },
                                domProps: { value: _vm.data.mileage_max }
                              })
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("tr", { staticClass: "field-group" }, [
                        _vm._m(8),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "field", attrs: { colspan: "3" } },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.proxy_data.transmission,
                                    expression: "proxy_data.transmission"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "transmission",
                                  name: "transmission"
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.proxy_data,
                                        "transmission",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function($event) {
                                      return _vm.onChange("transmission")
                                    }
                                  ]
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "", selected: "" } },
                                  [_vm._v("All")]
                                ),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "1" } }, [
                                  _vm._v("Manual")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "2" } }, [
                                  _vm._v("Automatic")
                                ]),
                                _vm._v(" "),
                                _c("option", { attrs: { value: "0" } }, [
                                  _vm._v("Unknown")
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group col-sm-12 search-clear-buttons"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              attrs: { type: "submit" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.doSearch.apply(null, arguments)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                    Search Vehicles\n                                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "link uppercase",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.clearForm.apply(null, arguments)
                                }
                              }
                            },
                            [_vm._v("Clear form")]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "advanced-options" }, [
                      _c("h3", [_vm._v("Advanced Options")]),
                      _vm._v(" "),
                      _c("table", { staticClass: "search" }, [
                        _c("tr", { staticClass: "field-group" }, [
                          _vm._m(9),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "field", attrs: { colspan: "3" } },
                            [
                              _c("input", {
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  readonly: "",
                                  id: "excluded-makes",
                                  name: _vm.getNameField(
                                    "excluded_makes",
                                    _vm.objectToString(_vm.excluded_makes_proxy)
                                  ),
                                  placeholder: "Excluded makes",
                                  autocomplete: "off"
                                },
                                domProps: {
                                  value: _vm.objectToString(
                                    _vm.excluded_makes_proxy
                                  )
                                },
                                on: {
                                  click: function($event) {
                                    _vm.show_exlude_makes_modal = true
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-modal",
                                {
                                  ref: "ExcludedModalMakes",
                                  attrs: {
                                    size: "lg",
                                    id: "excluded-modal-makes",
                                    title: "Exclude Makes",
                                    "hide-footer": ""
                                  },
                                  on: { hidden: _vm.onHideExcludeMakesModal },
                                  model: {
                                    value: _vm.show_exlude_makes_modal,
                                    callback: function($$v) {
                                      _vm.show_exlude_makes_modal = $$v
                                    },
                                    expression: "show_exlude_makes_modal"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "content-list-models" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "form-group inline-label"
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              attrs: {
                                                for: "excluded-makes-in-modal"
                                              }
                                            },
                                            [_vm._v("Exclude Makes")]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            attrs: {
                                              type: "text",
                                              readonly: "",
                                              id: "excluded-makes-in-modal",
                                              placeholder: "Excluded Makes"
                                            },
                                            domProps: {
                                              value: _vm.objectToString(
                                                _vm.excluded_makes_proxy
                                              )
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "link",
                                              attrs: { type: "button" },
                                              on: {
                                                click: _vm.clearExcludeMakes
                                              }
                                            },
                                            [_vm._v("Clear")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  _vm.show_exlude_makes_modal = false
                                                }
                                              }
                                            },
                                            [_vm._v("Done")]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "list-of-models" },
                                        _vm._l(_vm.all_makes, function(make) {
                                          return _c("div", [
                                            _c(
                                              "span",
                                              { staticClass: "checkbox" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm
                                                          .excluded_makes_proxy[
                                                          make.name
                                                        ],
                                                      expression:
                                                        "excluded_makes_proxy[make.name]"
                                                    }
                                                  ],
                                                  attrs: {
                                                    type: "checkbox",
                                                    id:
                                                      "excluded-makes-" +
                                                      make.name
                                                  },
                                                  domProps: {
                                                    value: make.name,
                                                    checked: Array.isArray(
                                                      _vm.excluded_makes_proxy[
                                                        make.name
                                                      ]
                                                    )
                                                      ? _vm._i(
                                                          _vm
                                                            .excluded_makes_proxy[
                                                            make.name
                                                          ],
                                                          make.name
                                                        ) > -1
                                                      : _vm
                                                          .excluded_makes_proxy[
                                                          make.name
                                                        ]
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a =
                                                          _vm
                                                            .excluded_makes_proxy[
                                                            make.name
                                                          ],
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = make.name,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              _vm.excluded_makes_proxy,
                                                              make.name,
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              _vm.excluded_makes_proxy,
                                                              make.name,
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          _vm.excluded_makes_proxy,
                                                          make.name,
                                                          $$c
                                                        )
                                                      }
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    attrs: {
                                                      for:
                                                        "excluded-makes-" +
                                                        make.name
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(make.name))]
                                                )
                                              ]
                                            )
                                          ])
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "field-group" }, [
                          _vm._m(10),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "field", attrs: { colspan: "3" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.proxy_data.chassis,
                                    expression: "proxy_data.chassis"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: _vm.getNameField("chassis"),
                                  id: "chassis",
                                  placeholder: "Chassis"
                                },
                                domProps: { value: _vm.proxy_data.chassis },
                                on: {
                                  change: function($event) {
                                    return _vm.onChange("chassis")
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.proxy_data,
                                      "chassis",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "field-group field-half" }, [
                          _vm._m(11),
                          _vm._v(" "),
                          _c("td", { staticClass: "field" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxy_data.engine_cc_min,
                                  expression: "proxy_data.engine_cc_min"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                name: _vm.getNameField("engine_cc_min"),
                                placeholder: "Min",
                                id: "engine_cc_min"
                              },
                              domProps: { value: _vm.proxy_data.engine_cc_min },
                              on: {
                                change: function($event) {
                                  return _vm.onChange("engine_cc_min")
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.proxy_data,
                                    "engine_cc_min",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _vm._m(12),
                          _vm._v(" "),
                          _c("td", { staticClass: "field" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxy_data.engine_cc_max,
                                  expression: "proxy_data.engine_cc_max"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: {
                                type: "text",
                                name: _vm.getNameField("engine_cc_max"),
                                placeholder: "Max",
                                id: "engine_cc_max"
                              },
                              domProps: { value: _vm.proxy_data.engine_cc_max },
                              on: {
                                change: function($event) {
                                  return _vm.onChange("engine_cc_max")
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.proxy_data,
                                    "engine_cc_max",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "field-group" }, [
                          _vm._m(13),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "field", attrs: { colspan: "3" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.proxy_data.lot,
                                    expression: "proxy_data.lot"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: _vm.getNameField("lot"),
                                  id: "lot",
                                  placeholder:
                                    "Lot #, Lot #, Lot #, Lot #, Lot #"
                                },
                                domProps: { value: _vm.proxy_data.lot },
                                on: {
                                  change: function($event) {
                                    return _vm.onChange("lot")
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.proxy_data,
                                      "lot",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "field-group" }, [
                          _vm._m(14),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "field", attrs: { colspan: "3" } },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.proxy_data.fuel_type,
                                      expression: "proxy_data.fuel_type"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  attrs: { id: "fuel_type" },
                                  on: {
                                    change: [
                                      function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.proxy_data,
                                          "fuel_type",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      },
                                      function($event) {
                                        return _vm.onChange("fuel_type")
                                      }
                                    ]
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    { attrs: { value: "", selected: "" } },
                                    [_vm._v("All")]
                                  ),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "p" } }, [
                                    _vm._v("petrol / unspecified")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "d" } }, [
                                    _vm._v("diesel")
                                  ]),
                                  _vm._v(" "),
                                  _c("option", { attrs: { value: "o" } }, [
                                    _vm._v("other")
                                  ])
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "field-group field-half" }, [
                          _vm._m(15),
                          _vm._v(" "),
                          _c("td", { staticClass: "field" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxy_data.start_bid_min,
                                  expression: "proxy_data.start_bid_min"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", id: "start_bid_min" },
                              domProps: { value: _vm.proxy_data.start_bid_min },
                              on: {
                                change: function($event) {
                                  return _vm.onChangeMinMax("start_bid_min")
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.proxy_data,
                                    "start_bid_min",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v(",000")]),
                            _vm._v(" "),
                            _vm.data.start_bid_min
                              ? _c("input", {
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "hidden",
                                    name: _vm.getNameField("start_bid_min")
                                  },
                                  domProps: {
                                    value: _vm.data.start_bid_min + "000"
                                  }
                                })
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm._m(16),
                          _vm._v(" "),
                          _c("td", { staticClass: "field" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxy_data.start_bid_max,
                                  expression: "proxy_data.start_bid_max"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", id: "start_bid_max" },
                              domProps: { value: _vm.proxy_data.start_bid_max },
                              on: {
                                change: function($event) {
                                  return _vm.onChangeMinMax("start_bid_max")
                                },
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.proxy_data,
                                    "start_bid_max",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _c("span", [_vm._v(",000")]),
                            _vm._v(" "),
                            _vm.data.start_bid_max
                              ? _c("input", {
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "hidden",
                                    name: _vm.getNameField("start_bid_max")
                                  },
                                  domProps: {
                                    value: _vm.data.start_bid_max + "000"
                                  }
                                })
                              : _vm._e()
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "field-group" }, [
                          _vm._m(17),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "field", attrs: { colspan: "3" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.proxy_data.colour,
                                    expression: "proxy_data.colour"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: _vm.getNameField("colour"),
                                  id: "colour",
                                  placeholder: "Colour"
                                },
                                domProps: { value: _vm.proxy_data.colour },
                                on: {
                                  change: function($event) {
                                    return _vm.onChange("colour")
                                  },
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.proxy_data,
                                      "colour",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("tr", { staticClass: "field-group field-half" }, [
                          _vm._m(18),
                          _vm._v(" "),
                          _c("td", { staticClass: "field" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.proxy_data.exclude_year_min,
                                    expression: "proxy_data.exclude_year_min"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "exclude_year_min",
                                  name: "exclude_year_min"
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.proxy_data,
                                        "exclude_year_min",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function($event) {
                                      return _vm.onChange("exclude_year_min")
                                    }
                                  ]
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "", selected: "" } },
                                  [_vm._v("Min")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.years, function(year) {
                                  return _c(
                                    "option",
                                    { domProps: { value: year } },
                                    [_vm._v(_vm._s(year))]
                                  )
                                })
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(19),
                          _vm._v(" "),
                          _c("td", { staticClass: "field" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.proxy_data.exclude_year_max,
                                    expression: "proxy_data.exclude_year_max"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  id: "exclude_year_max",
                                  name: "exclude_year_max"
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.proxy_data,
                                        "exclude_year_max",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function($event) {
                                      return _vm.onChange("exclude_year_max")
                                    }
                                  ]
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { value: "", selected: "" } },
                                  [_vm._v("Max")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.years, function(year) {
                                  return _c(
                                    "option",
                                    { domProps: { value: year } },
                                    [_vm._v(_vm._s(year))]
                                  )
                                })
                              ],
                              2
                            )
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("label", { attrs: { for: "make" } }, [_vm._v("Make")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "model" } }, [_vm._v("Model")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "year_min" } }, [_vm._v("Year")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "middle" }, [_c("span", [_vm._v("to")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "condition_min" } }, [
      _vm._v("Condition "),
      _c(
        "span",
        { staticClass: "show-tooltip", attrs: { id: "conditionToolTipPopup" } },
        [_vm._v("?")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "middle" }, [_c("span", [_vm._v("to")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "mileage_min" } }, [_vm._v("Mileage")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "middle" }, [_c("span", [_vm._v("to")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "transmission" } }, [_vm._v("Transmission")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "excluded-makes" } }, [
        _vm._v("Exclude Makes")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "chassis" } }, [_vm._v("Chassis")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "engine_cc_min" } }, [_vm._v("Engine CC")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "middle" }, [_c("span", [_vm._v("to")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("label", { attrs: { for: "lot" } }, [_vm._v("Lot#")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "fuel_type" } }, [
        _c("span", [_vm._v("Fuel Type")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "start_bid_min" } }, [
        _vm._v("Start Bid (YEN)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "middle" }, [_c("span", [_vm._v("to")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "colour" } }, [_vm._v("Colour")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [
      _c("label", { attrs: { for: "exclude_year_min" } }, [
        _vm._v("Exclude Year")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "middle" }, [_c("span", [_vm._v("to")])])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e045962", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e045962","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Forms/MarketResearch.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0e045962","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Forms/MarketResearch.vue
// module chunks = 0